import React, { Component, useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Table, Badge } from 'reactstrap';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';

const VendSystemContacts = (props) => {

    const [tableData, setTableData] = useState([])
    const dispatch = useDispatch()
    const selectRedux = state => state;
    const reduxData = useSelector(selectRedux);

    useEffect(() => {
        getData();
    }, [])

    useEffect(() => {
        getData();
    }, [props.syspk])

    function getData() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + reduxData.apiKey
        dispatch({ type: 'foundation/setFetchTime' })
        let toSend = {
            userLevel: reduxData.userInfo.level.pk,
            syspk: props.syspk
        }
        fetch('GetSystemContacts', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => { setTableData(responseJSON) })
        //localStorage.setItem("lastFetch", moment());
    }

    return (<div>
        <Table>
            <thead>
                <tr>
                    <th>Contact Name</th>
                    <th>Contact Responsibilities</th>
                    <th>Contact Address</th>
                    <th>Emails</th>
                    <th>Phone Numbers</th>
                    <th>Is Active?</th>
                </tr>
            </thead>
            <tbody>
                {tableData.map(item => (
                    <tr>
                        <td>{item.name}</td>
                        <td>{item.resp}</td>
                        <td>{item.address}</td>
                        <td>{item.emails.map(e => (
                            <div><Badge>{e}</Badge><br /></div>    
                        ))}</td>
                        <td>{item.phones.map(p => (
                            <div><Badge>{p}</Badge><br /></div>
                        ))}</td>
                        <td>{item.active}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    </div>)
}

export default VendSystemContacts;